import { render, staticRenderFns } from "./ObiDeviceCardMini.vue?vue&type=template&id=6d0bc687&scoped=true&"
import script from "./ObiDeviceCardMini.vue?vue&type=script&lang=js&"
export * from "./ObiDeviceCardMini.vue?vue&type=script&lang=js&"
import style0 from "./ObiDeviceCardMini.vue?vue&type=style&index=0&id=6d0bc687&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0bc687",
  null
  
)

export default component.exports